export default __webpack_public_path__ + "static/media/cities.0dada0b8.svg";